import "@/App.css";
import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { api } from "./lib/apiClient";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import ProjectDetail from "./pages/ProjectDetail";
import Subscribe from "./pages/Subscribe";
import AcceptInvite from "./pages/AcceptInvite";

const Loader = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#F9F8F6]">
    <div className="font-serif text-2xl text-[#A68A6B] tracking-wide animate-pulse">WorkRoom</div>
  </div>
);

function SubscriptionGate({ children }) {
  const { user } = useAuth();
  const [status, setStatus] = useState(null);

  const refresh = () => {
    if (user?.role === "designer") {
      api.get("/billing/status").then((r) => setStatus(r.data)).catch(() => setStatus({ access: true }));
    } else {
      setStatus({ access: true });
    }
  };
  useEffect(() => { refresh(); /* eslint-disable-next-line */ }, [user]);

  if (user?.role !== "designer") return children;
  if (!status) return <Loader />;
  if (!status.access) return <Subscribe onDone={refresh} />;
  return (
    <>
      {status.past_due && (
        <div data-testid="past-due-banner" className="bg-[#9E4747] text-white text-sm text-center px-4 py-2">
          Your last payment failed. Please update your card in <strong>Settings → Membership</strong> to keep your studio active.
        </div>
      )}
      {children}
    </>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Loader />;
  if (!user) return <Navigate to="/login" replace />;
  return <SubscriptionGate>{children}</SubscriptionGate>;
}

function Home() {
  const { user } = useAuth();
  return user?.role === "admin" ? <AdminDashboard /> : <Dashboard />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/" element={<Protected><Home /></Protected>} />
            <Route path="/projects/:id" element={<Protected><ProjectDetail /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
